/**----------------------------------------------------------------------------------------------------
 * Creates the flightline profile popup.
 *
 * European Union Public Licence V. 1.2
 * EUPL © the European Union 2007, 2016
 *
 * Modified: 2026, Eddy Scheper, ARIS BV
 */

import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Map from "ol/Map";
import View from "ol/View";
import MousePosition from "ol/control/MousePosition";
import {createStringXY} from "ol/coordinate";

import FlightColorTable from "./FlightColorTable";
import {zoomToExtent} from "./OLUtils";
import Profile from "./Profile";
import ProfileLegend from "./ProfileLegend";
import {ProfileLayout} from "./ProfileLayout";

/**-----------------------------------------------------------------------------
 */
export class FlightProfilePopup {

  app = null;

  options = null;

  showCoords = false;
  //showCoords = true;

  showLegendAtStartup = false;
  //showLegendAtStartup = true;

  mapTip = null;

  profile = null;
  profileMap = null;

  legend = null;

  nrCheckButtons = 0;

  layout = null;

  /**-----------------------------------------------------------------------------
   */
  constructor(app) {

    this.app = app;

    // Create the profiles.
    this.profile = new Profile(this.app);

    // Create the legend.
    this.legend = new ProfileLegend(this.app);
  }
  /**-----------------------------------------------------------------------------
   * @param target
   * @param showCoords
   * @param disableZoom
   */
  createMap(target,showCoords,disableZoom) {
    let map,source,layer;
    let backSource,backLayer,legendSource,legendLayer;
    let result,mousePosition;

    console.log("#FlightProfilePopup.createMap() - Target: "+target);

    // Create vector source and layer.
    source = new VectorSource({});
    layer = new VectorLayer({source: source});

    // Create legend background vector source and layer.
    backSource = new VectorSource({});
    backLayer = new VectorLayer({source: backSource});

    // Create legend vector source and layer.
    legendSource = new VectorSource({});
    legendLayer = new VectorLayer({source: legendSource});

    // Create chart 'map'.
    map = new Map({
      controls: [],
      layers: [layer,backLayer,legendLayer],
      target: target,
      view: new View({
        center: [0,3000000],
        zoom: 2,
      }),
    });

    // Create coordinates control?
    if (showCoords) {
      mousePosition = new MousePosition({
        className: "custom-mouse-position",
        coordinateFormat: createStringXY(1),
        undefinedHTML: "&nbsp;"
      });
      map.addControl(mousePosition);
    }

    // Disable zoom?
    if (disableZoom) {
      map.getInteractions().clear();
    }

    // Prevent event propagation from the map to the popup.
    document.getElementById(target).addEventListener("mousedown", function(e) {
      e.stopPropagation();
    });
    document.getElementById(target).addEventListener("mousemove", function(e) {
      e.stopPropagation();
    });

    result = {
      map: map,
      source: source,
      backSource: backSource,
      legendSource: legendSource,
      layer: layer,
    }
    return result;
  }
  /**-----------------------------------------------------------------------------
   * Zie profileinteraction.
   * @param options
   */
  createPopup(options) {
    let self = this;
    let value_fields,panel;
    let d, value, input, inputType, group, labelText, checked, btn;
    let i, len;

    console.log("#FlightProfilePopup.createPopup()");

    console.log("Options:");
    console.log(options);

    value_fields = options.value_fields;

    this.nrCheckButtons = value_fields.length;

    // Get main container div and show.
    panel = document.getElementById("vlchartpopup");
    panel.style.display = "block";

    // Close button.
    d = '<a href="#" id="btnCloseVL" class="chartclosebtn"><i class="fa fa-times" aria-hidden="true"></i></a>';

    //------------------------------------------------------------------------
    // Toppanel.
    //------------------------------------------------------------------------
    d += "<div id='vlcharttoppanel'>";

    inputType = "type='radio'";
    group = "name='flightline'";

    for (i = 0, len = value_fields.length; i < len; i++) {
      value = value_fields[i];
      input = "<input id='vlchartcheck_" + i + "'" + " class='chartinput' " + inputType + group + "/>";
      labelText = value.replace("_", " ");
      d += "  <div class='vlchartcheck'><label>" + input + labelText + "</label></div>";
    }

    // Legenda checkbox.
    if (this.showLegendAtStartup) {
      checked = "checked";
    } else {
      checked = "";
    }
    input = "<input id='vlchartcheck_legend' class='chartinput' type='checkbox' " + checked + "/>";
    labelText = "legenda"
    d += "<div class='chartcheck chartsuit'><label>" + input + labelText + "</label></div>";

    d += "<a id='vlimage-download' download='map.png'></a>";

    //------------------------------------------------------------------------
    // Panel.
    //------------------------------------------------------------------------

    d += "</div>";
    d += "<div id='vlchartpanel'>";
    d += "  <div id='vlcharttopbar'>"
    d += "<span id='btnDownloadPNGVL' class='charticon' title='Download als PNG'>";
    d += "<svg viewBox='0 0 1000 1000' height='1em' width='1em'>";
    d += "<path ";
    d += "d='m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z' ";
    d += "transform='matrix(1 0 0 -1 0 850)'></path>";
    d += "</svg>";
    d += "</span>";
    d += "<span id='btnHomeVL' class='charticon' title='Helemaal uitzoomen'>";
    d += "<svg viewBox='0 0 1000 1000' height='1em' width='1em'>";
    d += "<path ";
    d += "d='m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z' ";
    d += "transform='matrix(1 0 0 -1 0 850)'></path>";
    d += "</svg>";
    d += "</a>";

    //------------------------------------------------------------------------
    // ChartContainer with ChartProfile and ChartLegend.
    //------------------------------------------------------------------------

    d += "  </div>";
    d += "  <div id='vlchartcontainer'>";
    d += "    <div id='vlchartprofile' class='chartprofile'>";
    d += "      <div id='vlchartinfo' class='chartinfo'></div>";
    d += "    </div>";
    d += "  </div>";
    d += "  <div id='vlchartcoordinates'></div>";
    d += "</div>";

    panel.innerHTML = d;

    // Add event handlers and create profile(s).
    console.log("Value_fields:");
    console.log(value_fields);

    for (i = 0, len = value_fields.length; i < len; i++) {
      btn = document.getElementById("vlchartcheck_" + i);
      btn.addEventListener("click", function () {
        self.onOptionsChanged();
      });
    }
    btn = document.getElementById("vlchartcheck_legend");
    if (btn) {
      btn.addEventListener("click", function () {
        self.onOptionsChanged();
      });
    }

    // Show the default profile.
    this.onOptionsChanged();
  }
  /**-----------------------------------------------------------------------------
   * checkedOptions = array met de statussen van de radio's en de checkbox.
   */
  drawFlightProfiles(profileMap,options,checkedOptions,initialExtent) {
    let colorTable, chlorideTypes;
    let showLegend;
    let i, len;

    console.log("#FlightProfilePopup.drawFlightProfiles()");

    console.log("options:");
    console.log(options);

    // Initial extent?
    if (initialExtent) {
      // Zoom.
      zoomToExtent(profileMap.map, this.layout.zoomExtent);
      console.log("ZoomExtent: " + this.layout.zoomExtent);
    }

    // Get flight color table?
    colorTable = this.app.flightColorTable;

    //---------------------------------------------------------
    // Draw flight profile.
    //---------------------------------------------------------

    // Get profile chloride types.
    chlorideTypes = options.value_fields;

    // Draw chloride type profile.
    for (i = 0, len = chlorideTypes.length; i < len; i++) {
      if (checkedOptions[i]) {
        this.profile.drawFlightProfile(profileMap.source,options,this.layout,chlorideTypes[i],colorTable);
      }
    }

    //---------------------------------------------------------
    // Draw legend.
    //---------------------------------------------------------

    console.log(checkedOptions);

    // Get last checkOption, ie. show legend.
    showLegend = this.isLegendChecked(checkedOptions);

    console.log(showLegend);

    if (showLegend) {
      this.drawLegend(this.profileMap);
    }
  }
  /**-----------------------------------------------------------------------------
   * Draw legends (from bottom to top).
   */
  drawLegend(profileMap) {
    let layout, colorTable;

    console.log("#FlightProfilePopup.drawLegend()");

    layout = ProfileLayout.getFlightLegendLayout();
    colorTable = this.app.flightColorTable;
    this.legend.drawFlightLegend(profileMap.backSource,profileMap.legendSource,layout,colorTable);
  }
  /**-----------------------------------------------------------------------------
   */
  elementGetClientXY(id) {
    let elt, clientRect;
    elt = document.getElementById(id);
    clientRect = elt.getBoundingClientRect();
    return [clientRect.left, clientRect.top];
  }
  /**-----------------------------------------------------------------------------
   */
  exportRenderLayers(map,mapContext) {
    let opacity,matrix,transform;
    let backgroundColor;

    Array.prototype.forEach.call(
        map.getViewport().querySelectorAll(".ol-layer canvas, canvas.ol-layer"),
        function (canvas) {
          if (canvas.width > 0) {
            opacity = canvas.parentNode.style.opacity || canvas.style.opacity;
            mapContext.globalAlpha = opacity === "" ? 1 : Number(opacity);
            transform = canvas.style.transform;
            if (transform) {
              // Get the transform parameters from the style"s transform matrix.
              matrix = transform
                  .match(/^matrix\(([^\(]*)\)$/)[1]
                  .split(",")
                  .map(Number);
            } else {
              matrix = [parseFloat(canvas.style.width) / canvas.width, 0, 0,
                parseFloat(canvas.style.height) / canvas.height, 0, 0,
              ];
            }
            // Apply the transform to the export map context.
            CanvasRenderingContext2D.prototype.setTransform.apply(
                mapContext,
                matrix,
            );
            backgroundColor = "white";
            if (backgroundColor) {
              mapContext.fillStyle = backgroundColor;
              mapContext.fillRect(0, 0, canvas.width, canvas.height);
            }
            mapContext.drawImage(canvas, 0, 0);
          }
        }
    );
  }
  /**-----------------------------------------------------------------------------
   */
  exportToPNG() {
    let self = this;
    let mapCanvas,size,mapContext,link;
    let map;
    map = this.profileMap.map;
    map.once("rendercomplete", function () {
      mapCanvas = document.createElement("canvas");
      size = map.getSize();
      mapCanvas.width = size[0];
      mapCanvas.height = size[1];
      mapContext = mapCanvas.getContext("2d");
      self.exportRenderLayers(map,mapContext);
      mapContext.globalAlpha = 1;
      mapContext.setTransform(1, 0, 0, 1, 0, 0);
      link = document.getElementById("vlimage-download");
      link.download = "freshem_vlprofiel.png";
      link.href = mapCanvas.toDataURL();
      link.click();
    });
    map.renderSync();
  }
  /**-----------------------------------------------------------------------------
   */
  getCheckedOptions() {
    let btn,result;
    let i,len;
    result = [];
    for (i = 0, len = this.nrCheckButtons; i < len; i++) {
      btn = document.getElementById("vlchartcheck_" + i);
      result.push(btn.checked);
    }
    btn = document.getElementById("vlchartcheck_legend");
    if (btn) {
      result.push(btn.checked);
    } else {
      result.push(false);
    }
    return result;
  }
  /**-----------------------------------------------------------------------------
   * Install the button event handlers.
   */
  initControls() {
    let self = this;
    let btn;

    console.log("#FlightProfilePopup.initControls()");

    btn = document.getElementById("btnCloseVL");
    if (btn) {
      btn.addEventListener("click", function () {
        self.onButtonCloseClick();
      }, false);
    }
    btn = document.getElementById("btnDownloadPNGVL");
    if (btn) {
      btn.addEventListener("click", function () {
        self.onButtonDownloadPNGClick();
      }, false);
    }
    btn = document.getElementById("btnHomeVL");
    if (btn) {
      btn.addEventListener("click", function () {
        self.onButtonZoomFullExtentClick();
      }, false);
    }
    btn = document.getElementById("btnCloseVL");
    if (btn) {
      btn.addEventListener("click", function () {
        self.onButtonCloseClick();
      }, false);
    }
  }
  /**-----------------------------------------------------------------------------
   * @param map
   */
  installHoverHandler(map) {
    let self = this;

    // Get the map tip element.
    self.mapTip = document.getElementById("vlchartinfo");

    // Install map event handlers for hovering.
    map.on("pointermove", function (evt) {
      if (evt.dragging) {
        self.mapTip.style.visibility = "hidden";
        self.currentFeature = undefined;
        return;
      }
      self.onHover(map,self.mapTip,evt);
    });
  }
  /**-----------------------------------------------------------------------------
   */
  isLegendChecked(checkOptions) {
    return checkOptions[checkOptions.length-1];
  }
  /**-----------------------------------------------------------------------------
   */
  isMapCoordinateInProfile(mapX,mapY) {
    let x,y,width,height;
    let minX,minY,maxX,maxY;

    // Get Profile center and bottom.
    x = this.layout.positionsX[0];
    y = this.layout.positionsY[0];

    // Profile size.
    width = this.layout.columnWidth;
    height = this.layout.columnHeight;

    // Check.
    minX = x - (width / 2);
    maxX = minX + width;
    if ((mapX < minX) || (mapX > maxX)) {
      return false;
    }
    minY = y;
    maxY = y + height;

    // noinspection RedundantIfStatementJS
    if ((mapY < minY) || (mapY > maxY)) {
      return false;
    } else {
      return true;
    }
  }
  /**-----------------------------------------------------------------------------
   */
  onButtonCloseClick() {
    $("#btnCloseVL").parent().hide();
    if (this.options.src) {
      this.options.src.clear();
    }
    if (this.options.result_src) {
      this.options.result_src.clear();
    }
  }
  /**-----------------------------------------------------------------------------
   */
  onButtonDownloadPNGClick() {
    this.exportToPNG();
  }
  /**-----------------------------------------------------------------------------
   */
  onButtonZoomFullExtentClick() {
    zoomToExtent(this.profileMap.map,this.layout.zoomExtent);
  }
  /**-----------------------------------------------------------------------------
   */
  onHover(map,mapTip,evt) {
    let features,feature,mapCoords,pixel,clientXY1,clientXY2;
    let offsetX,offsetY,mapTipX,mapTipY,mapTipText,text,linkId;
    let controlHighlight,highlightFeature,selectedFeatures;
    let tag,tagsFound;
    let i,len;

    //console.log("onhover");

    // Get mapcoordinates and check.
    mapCoords = map.getCoordinateFromPixel(evt.pixel);
    if (!this.isMapCoordinateInProfile(mapCoords[0],mapCoords[1])) {
      // Clear highlight.
      controlHighlight = this.app.controlHighlight;
      selectedFeatures = controlHighlight.getFeatures();
      selectedFeatures.clear();
      // Hide maptip.
      mapTip.style.visibility = "hidden";
      return;
    }

    // Get pixel.
    pixel = map.getEventPixel(evt.originalEvent);

    // Get features.
    features = [];
    map.forEachFeatureAtPixel(pixel,function(feature) {
      features.push(feature);
    });

    if (features.length > 0) {

      // Get feature.
      feature = features[0];

      // Get map offset.
      clientXY1 = this.elementGetClientXY("vlchartprofile");
      clientXY2 = this.elementGetClientXY("vlchartpopup");
      offsetX = clientXY1[0] - clientXY2[0];
      offsetY = clientXY1[1] - clientXY2[1];

      // Must be relative to chartpopup.
      mapTipX = offsetX + pixel[0];
      mapTipY = offsetY + pixel[1] - mapTip.offsetHeight;

      mapTip.style.left = mapTipX + "px";
      mapTip.style.top = mapTipY + "px";
      mapTipText = "";

      linkId = null;

      tagsFound = []
      for (i = 0, len = features.length; i < len; i++) {
        feature = features[i];
        tag = feature.get("tag");
        if (tagsFound.includes(tag)) {
          continue;
        }
        tagsFound.push(tag);
        text = feature.get("text");
        if (text !== undefined) {
          if (mapTipText === "") {
            mapTipText = text;
          } else {
            mapTipText = text + "\n" + mapTipText;
          }
        }
        linkId = feature.get("linkId");
        if (tagsFound.length===2) {
          break;
        }
      }

      if (linkId) {
        // Highlight feature.
        highlightFeature = this.options.result_src.getFeatureById(linkId);
        if (highlightFeature) {
          controlHighlight = this.app.controlHighlight;
          selectedFeatures = controlHighlight.getFeatures();
          selectedFeatures.clear();
          selectedFeatures.push(highlightFeature);
        } else {
          controlHighlight = this.app.controlHighlight;
          selectedFeatures = controlHighlight.getFeatures();
          selectedFeatures.clear();
        }
      }
      if (mapTipText !== "") {
        // Show maptip.
        mapTip.style.visibility = "visible";
        mapTip.innerText = mapTipText;
      } else {
        mapTip.style.visibility = "hidden";
      }
    } else {
      controlHighlight = this.app.controlHighlight;
      selectedFeatures = controlHighlight.getFeatures();
      selectedFeatures.clear();

      mapTip.style.visibility = "hidden";
    }
  }
  /**-----------------------------------------------------------------------------
   */
  onOptionsChanged() {
    let checkedProfileOptions;
    let startTime,endTime;

    console.log("#FlightProfilePopup.onOptionsChanged()");

    // Check if initialized.
    if (!this.profileMap) {
      return;
    }

    // Clear profiles and legend.
    this.profileMap.source.clear();
    this.profileMap.backSource.clear();
    this.profileMap.legendSource.clear();

    // Get checked profile options and draw the corresponding profiles.
    checkedProfileOptions = this.getCheckedOptions();

    // Show performance timings?
    if (this.app.config.TEST_SHOW_PERFORMANCE_TIMINGS) {
      startTime = performance.now();
    }

    // Redraw profiles.
    this.drawFlightProfiles(this.profileMap,this.options,checkedProfileOptions,false);

    // Show performance timings?
    if (this.app.config.TEST_SHOW_PERFORMANCE_TIMINGS) {
      endTime = performance.now();
      if (window.consoleLog)
        window.consoleLog("Elapsed (msec): " + (endTime - startTime));
    }
  }
  /**-----------------------------------------------------------------------------
   */
  setCheckedOptions(options) {
    let value,checkElt;
    let i,len;
    for (i = 0, len = options.value_fields.length; i < len; i++) {
      value = options.value_fields[i];
      if (options.default_plots.includes(value)) {
        checkElt = document.getElementById("vlchartcheck_"+i);
        if (checkElt) {
          checkElt.checked = true;
        }
      }
    }
  }
  /**-----------------------------------------------------------------------------
   * Shows the popup.
   * Called in: FlightProfileControl.processFeatures()
   * @param options
   */
  showPopup(options) {
    let checkedProfileOptions;

    try {

      console.log("#FlightProfilePopup.showPopup()");

      console.log(options);

      // Save options because of onOPtionsChanged.
      this.options = options;

      // Set the layout.
      if (!this.layout) {
        this.layout = ProfileLayout.getProfileLayout(this.options.geomType)
      }

      // Set the app colortable.
      if (!this.app.flightColorTable) {
        this.app.flightColorTable = new FlightColorTable();
      }

      // Create the popup.
      this.createPopup(options);

      // Create the map.
      this.profileMap = this.createMap("vlchartprofile",this.showCoords, false);

      // Create the profile map tip.
      this.installHoverHandler(this.profileMap.map);

      // Install event handlers.
      this.initControls();

      // Set checked profile options based on the general options.
      this.setCheckedOptions(options);

      // Get checked profile options.
      checkedProfileOptions = this.getCheckedOptions();

      // Draw the corresponding profiles.
      this.drawFlightProfiles(this.profileMap,options,checkedProfileOptions,true);

    } catch(error) {
      console.error(error);
    }
  }
}
